import * as types from '../mutation-types';
export default {
  state: {
    phoneCallStatus: 0,// 是否vr语音带看，0=未带看，1=带看中
  },
  mutations: {
    [types.SET_PHONE_CALL_STATUS]: function (state, { phoneCallStatus }) {
      state.phoneCallStatus = phoneCallStatus;
    }
  },
  getters: {
    phoneCallStatus: state => state.phoneCallStatus
  },
  actions: {
    onCall ({ commit }) {
      commit(types.SET_PHONE_CALL_STATUS, {phoneCallStatus:1});
    },
    offCall ({ commit }) {
      commit(types.SET_PHONE_CALL_STATUS, {phoneCallStatus:0});
    }
  },
  namespaced: true
};